var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-container',{staticClass:"text-center"},[_c('icon-logo',{attrs:{"height":"60px"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }